export const DEBOUNCE_DELAY = 500;
export const CHARACTER_LENGTH_THRESHOLD = 3;
